import isEmpty from "lodash/isEmpty";
import { useEffect } from "react";
import { connect } from "react-redux";
import { IconReports } from "../../../../components/Icon/Icon";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import "./NavBarReportsBadge.scss";

type Props = {
  isActive: boolean;
  isLightWhenActive: boolean;
  currentBetsCount: number;
  loadCurrentBetsCount: Function;
  isIdle: boolean;
};

const NavBarReportsBadge = (props: Props) => {
  useEffect(() => {
    if (SessionHelper.isAuthenticated()) {
      const reportCountInterval = setInterval(() => {
        if (!isEmpty(props)) return;

        if (!props.isIdle) {
          props.loadCurrentBetsCount();
        }
      }, 5000);

      return () => {
        clearInterval(reportCountInterval);
      };
    }
  }, [props]);

  const { isActive, isLightWhenActive, currentBetsCount } = props;

  return (
    <div className="nav-bar-reports-badge">
      <div className="nav-bar-reports-badge__badge">{currentBetsCount}</div>
      <IconReports isActive={isActive} isLightWhenActive={isLightWhenActive} />
    </div>
  );
};

const mapStateToProps = state => ({
  currentBetsCount: state.betSlipListModel.currentBetsCount,
  isIdle: state.sessionModel.isIdle,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    loadCurrentBetsCount: () =>
      dispatch.betSlipListModel.loadCurrentBetsCount(),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBarReportsBadge);
